import { Grid, makeStyles, TextField, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
// import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import { FlashOn, Schedule } from '@material-ui/icons';
import dateUtil from '../util/dateUtil';
var datefns = require('date-fns');

const TimeInput = ({ value, label, onChange, disabled, smallVersion, ...props }) => {
  const [localValue, setLocalValue] = useState(
    dateUtil.stringToTimeFormat(value, 'HH:mm')
  );

  useEffect(() => {
    setLocalValue(dateUtil.stringToTimeFormat(value, 'HH:mm'));
  }, [value]);

  //this is used to "clear" the control
  useEffect(() => {
    if (localValue == '00:00') setLocalValue('');
  }, [localValue]);

  const setNow = () => {
    onChange(dateUtil.nowTimeString());
  };

  return (
    <Grid container container style1={{ position: 'relative' }}>
      <Grid item xs={12}>
        <TextField
          label=""
          type="time"
          value={localValue || ''}
          disabled={disabled}
          error={props.error}
          helperText={props.helperText}
          onChange={(e) => {
            if (e) setLocalValue(e.target.value);
          }}
          onBlur={(e) => {
            if (
              datefns.isValid(
                datefns.parseISO('1900-01-01T' + e.target.value + ':00.000Z')
              )
            )
              onChange('1900-01-01T' + e.target.value + ':00.000Z');
            else {
              setLocalValue('00:00');
              onChange(null);
            }
          }}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 min
          }}
          style={{ width: 106 }}
        />
        {!disabled && (
          <FlashOn onClick={setNow} fontSize="small" style={{ marginTop: 6 }} />
        )}
      </Grid>
    </Grid>
  );
};

export default TimeInput;
